export default "__VITE_ASSET__DyfP91No__"